import { NameDto } from '../../Common/Types'

export interface TransactionTypeDto {
  id: number
  name: string | null
  transactionBaseType: NameDto
  directionType: NameDto | null
}

export enum TransactionType {
  WalletTransfer = 100,
  DepositFromPaymentAgent = 112,
  WithdrawToPaymentAgent = 114,
  WalletDeposit = 200,
  WalletWithdrawal = 300,
  TransferFromTradingAccount = 400,
  TransferToTradingAccount = 500,
  ManualAdjustment = 610,
  Refund = 630,
  WelcomeAccountReward = 640,
  TradingIssueCompensation = 650,
  BonusTransfer = 660,
  IBCommission = 670,
  MIBCommission = 675,
  IBMultiTier = 676,
  IBCashBacks = 682,
  BankFeesRefund = 685,
  NegativeEquityRefund = 710,
  ZuluTradeManagementFee = 720,
  ZuluTradeSubscriptionFee = 730,
  ManualTradingAccountAdjustment = 740,
}

export const isTransactionWalletWithdrawalType = (type?: TransactionType) => {
  return TransactionType.WalletWithdrawal === type
}

export const isIBCommission = (transactionType: number): boolean => {
  return (
    transactionType === TransactionType.IBCommission ||
    transactionType === TransactionType.MIBCommission ||
    transactionType === TransactionType.IBMultiTier
  )
}

export const isWalletWithdrawal = (transactionType: number): boolean => {
  return transactionType === TransactionType.WalletWithdrawal
}

export const isDepositFromPaymentAgent = (transactionType: number): boolean => {
  return transactionType === TransactionType.DepositFromPaymentAgent
}

export enum TransactionBaseType {
  WaToWa = 100,
  PspToWa = 200,
  WaToPsp = 300,
  TaToWa = 400,
  WaToTa = 500,
  SingleWa = 600,
  SingleTa = 700,
}
